function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 240 240",
    style: {
      enableBackground: "new 0 0 240 240"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#65BC50",
      strokeWidth: 2
    },
    cx: 120,
    cy: 120,
    r: 119
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#65BC50"
    },
    cx: 120,
    cy: 120,
    r: 112
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 72,
    style: {
      opacity: 0.01,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    width: 96,
    height: 96
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    d: "M113.5,160.6c-1.7,0-3.3-0.7-4.5-1.9l-27.9-27.9 c-1.6-1.6-1.6-4.1,0-5.7c1.6-1.6,4.1-1.6,5.7,0l26.3,26.3L152.5,82c0.7-1.3,2-2,3.5-2s2.8,0.7,3.5,2c0.7,1.2,0.7,2.8,0,4L119,157.4 c-1,1.7-2.7,2.9-4.6,3.2C114.1,160.6,113.8,160.6,113.5,160.6z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkBig);
export default __webpack_public_path__ + "static/media/checkmark-big.0732ef6253b5fea42c8f2eff150f8ac8.svg";
export { ForwardRef as ReactComponent };